import { Events } from '@phx-husky/auth-service';
import { useAuth } from '@phx-husky/use-auth';
import { useState, useEffect } from 'react';

const useUserSession = () => {
    const auth = useAuth();
    const [currentUser, setCurrentUser] = useState(null);
    const [userLoading, setUserLoading] = useState('idle');
    const isSignedIn = () => {
        if (!currentUser) {
            return false;
        }
        if (auth.isPasswordProviderUser()) {
            return currentUser.emailVerified === true;
        }
        return true;
    };
    const isSignedUp = () => {
        if (!currentUser) {
            return false;
        }
        if (auth.isPasswordProviderUser()) {
            return currentUser.emailVerified === false;
        }
        return false;
    };
    const isSignedOut = () => !currentUser;
    useEffect(() => {
        setUserLoading('idle');
        const onAuthStateChange = () => {
            const user = auth.getCurrentUser();
            setUserLoading('loading');
            setCurrentUser(user);
            setUserLoading('success');
        };
        onAuthStateChange();
        window.addEventListener(Events.onAuthStateChange, onAuthStateChange);
        return () => {
            window.removeEventListener(Events.onAuthStateChange, onAuthStateChange);
        };
    }, [auth]);
    return {
        signOut: auth.signOut,
        setRememberMe: auth.setRememberMe,
        getRememberMeConfig: auth.getRememberMeConfig,
        currentUser,
        userLoading,
        isSignedIn,
        isSignedUp,
        isSignedOut,
    };
};

export { useUserSession };
